import createYCloudIcon from '../createYCloudIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M14 2v5a1 1 0 0 0 1 1h5', key: 'wfsgrz' }],
  [
    'path',
    {
      d: 'M14.692 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v3.804',
      key: '2jnu99',
    },
  ],
  ['path', { d: 'M2.264 13.752 7 16.5l4.737-2.748', key: 't73mg3' }],
  [
    'path',
    {
      d: 'M2.995 13.014A2 2 0 0 0 2 14.744v3.516a2 2 0 0 0 .996 1.73l3 1.74a2 2 0 0 0 2.008 0l3-1.74A2 2 0 0 0 12 18.26v-3.517a2 2 0 0 0-.995-1.73l-3-1.742a2 2 0 0 0-1.892-.064z',
      key: '16ed4v',
    },
  ],
  ['path', { d: 'M7 16.5V22', key: '1i1gou' }],
];

/**
 * @component @name FileBox
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMnY1YTEgMSAwIDAgMCAxIDFoNSIgLz4KICA8cGF0aAogICAgZD0iTTE0LjY5MiAyMkgxOGEyIDIgMCAwIDAgMi0yVjhhMi40IDIuNCAwIDAgMC0uNzA2LTEuNzA2bC0zLjU4OC0zLjU4OEEyLjQgMi40IDAgMCAwIDE0IDJINmEyIDIgMCAwIDAtMiAydjMuODA0IgogIC8+CiAgPHBhdGggZD0iTTIuMjY0IDEzLjc1MiA3IDE2LjVsNC43MzctMi43NDgiIC8+CiAgPHBhdGgKICAgIGQ9Ik0yLjk5NSAxMy4wMTRBMiAyIDAgMCAwIDIgMTQuNzQ0djMuNTE2YTIgMiAwIDAgMCAuOTk2IDEuNzNsMyAxLjc0YTIgMiAwIDAgMCAyLjAwOCAwbDMtMS43NEEyIDIgMCAwIDAgMTIgMTguMjZ2LTMuNTE3YTIgMiAwIDAgMC0uOTk1LTEuNzNsLTMtMS43NDJhMiAyIDAgMCAwLTEuODkyLS4wNjR6IgogIC8+CiAgPHBhdGggZD0iTTcgMTYuNVYyMiIgLz4KPC9zdmc+Cg==) - https://tianjianjun0727.github.io/ycloud-icons/icons/file-box
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/react - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileBox = createYCloudIcon('file-box', __iconNode);

export default FileBox;
